// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"cd08a830","455":"05fe135b","977":"f7407683"}[chunkId] + ".chunk.js";
};